import { ROUTES } from "../constants";

const EXPIRED_TRIAL_ALLOWED_ROUTES = [ROUTES.header.contactSupport] as const;

export const isExpiredTrialRouteAllowed = (pathname: string): boolean =>
  EXPIRED_TRIAL_ALLOWED_ROUTES.includes(
    pathname as (typeof EXPIRED_TRIAL_ALLOWED_ROUTES)[number],
  );
